var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    [
      _c("FormsAutocomplete", {
        attrs: {
          item: _setup.collection,
          label: _vm.label,
          clearable: _vm.clearable,
          disabled: _vm.disabled,
          multiple: _vm.multiple,
          "show-add": _vm.showAdd,
          "error-messages": _vm.errorMessages,
          dense: _vm.dense,
          "store-action": "domainCourse/ActionGetCourses",
          filters: _setup.applyFilter,
          "load-data": _vm.loadData,
        },
        on: {
          onShowFormCreate: (value) => (_setup.showFormCreate = value),
          "update:filters": function ($event) {
            _setup.applyFilter = $event
          },
        },
        model: {
          value: _setup.model,
          callback: function ($$v) {
            _setup.model = $$v
          },
          expression: "model",
        },
      }),
      _c("sys-register-course", {
        attrs: { model: {}, show: _setup.showFormCreate },
        on: {
          onCompleted: _setup.newItem,
          "update:show": function ($event) {
            _setup.showFormCreate = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }